export default {
  //campos de tabla TARJETA / CARD
  cardFields: [
    {
      key: "id_tarjeta",
      label: "ID",
      sortable: true,
    },
    {
      key: "folio",
      label: "Folio",
      sortable: true,
    },
    {
      key: "nombre_empresa",
      label: "Empresa",
      sortable: true,
    },
    {
      key: "nombre_municipio",
      label: "Municipio",
      sortable: true,
    },
    {
      key: "estatus_entrega",
      label: "Estatus de entrega",
      sortable: true,
    },
    {
      key: "estatus",
      label: "Estado",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ],

   //campos de tabla MUJERES / WOMEN
   womanFields: [
    {
      key: "folio_tarjeta",
      label: "Tarjeta",
      sortable: true,
    },
    {
      key: "nombre",
      label: "Nombre",
      sortable: true,
    },
    {
      key: "curp",
      label: "Curp",
      sortable: true,
    },
    {
      key: "nombre_municipio",
      label: "Municipio",
      sortable: true,
    },
    {
      key: "fecha_creacion",
      label: "Fecha de creación",
      sortable: true,
    },
    {
      key: "fecha_modificacion",
      label: "Última modificación",
      sortable: true,
    },
    {
      key: "estatus",
      label: "Estado",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ],

  //campos de tabla MUNICIPIOS / MUNICIPALITIES
  municipiosFields: [
    {
      key: "id_municipio",
      label: "ID",
      sortable: true,
    },
    {
      key: "nombre",
      label: "Nombre del municipio",
      sortable: true,
    },
    {
      key: "total_mujeres",
      label: "Total de registros",
      sortable: true,
    },
    {
      key: "estatus",
      label: "Estado",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ],

  //campos de tabla EMPRESAS / ENTERPRISES
  empresasFields: [
    {
      key: "id_empresa",
      label: "ID",
      sortable: true,
    },
    {
      key: "nombre",
      label: "Nombre de la empresa",
      sortable: true,
    },
    {
      key: "total_folios",
      label: "Total de tarjetas",
      sortable: true,
    },
    {
      key: "folio_inicio",
      label: "Rango de tarjetas",
      sortable: true,
    },
    {
      key: "fecha_entrega",
      label: "Fecha de entrega",
      sortable: true,
    },
    {
      key: "semaforo",
      label: "Estatus de entrega",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ],

  //campos de tabla PUNTOS DE ENTREGA / DELIVERY POINTS
  puntosentregaFields: [
    {
      key: "id_punto_entrega",
      label: "ID",
      sortable: true,
    },
    {
      key: "nombre",
      label: "Punto de entrega",
      sortable: true,
    },
    {
      key: "tipo",
      label: "Tipo",
      sortable: true,
    },
    {
      key: "estatus",
      label: "Estado",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ],

  //campos de tabla NEGOCIOS / BUSINESS
  negociosFields: [
    {
      key: "id_negocio",
      label: "ID",
      sortable: true,
    },
    {
      key: "logotipo",
      label: "Imagen",
      sortable: true,
    },
    {
      key: "nombre",
      label: "Punto de entrega",
      sortable: true,
    },
    {
      key: "fecha",
      label: "Fecha de Creación",
      sortable: true,
    },
    {
      key: "estatus",
      label: "Estado",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ],

  //campos de tabla CATEGORIAS / CATEGORIES
  categoriasFields: [
    {
      key: "id_cat_descuento",
      label: "ID",
      sortable: true,
    },
    {
      key: "imagen",
      label: "Imagen",
      sortable: true,
    },
    {
      key: "nombre",
      label: "Nombre",
      sortable: true,
    },
    {
      key: "fecha",
      label: "Fecha de Creación",
      sortable: true,
    },
    {
      key: "estatus",
      label: "Estado",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ],

  //campos de tabla DESCUENTOS / DISCOUNTS
  descuentosFields: [
    {
      key: "id_descuento",
      label: "ID",
      sortable: true,
    },
    {
      key: "imagen",
      label: "Imagen",
      sortable: true,
    },
    {
      key: "nombredescripcion",
      label: "Nombre",
      sortable: true,
    },
    {
      key: "nombre_negocio",
      label: "Negocio",
      sortable: true,
    },
    {
      key: "fecha",
      label: "Fecha de Creación",
      sortable: true,
    },
    {
      key: "vigencia",
      label: "Vigencia",
      sortable: true,
    },
    {
      key: "estatus",
      label: "Estado",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ],

  //campos de tabla USUARIOS ADMIN / ADMINUSER
  usuariosAdminFields: [
    {
      key: "id_usuario",
      label: "ID",
      sortable: true,
    },
    {
      key: "nombrepaternomaterno",
      label: "Nombre de usuario",
      sortable: true,
    },
    {
      key: "id_tipo",
      label: "Tipo",
      sortable: true,
    },
    {
      key: "nombre_negocio",
      label: "Negocio",
      sortable: true,
    },
    {
      key: "nombre_municipio",
      label: "Ciudad",
      sortable: true,
    },
    {
      key: "email",
      label: "Email",
      sortable: true,
    },
    {
      key: "estatus",
      label: "Estado",
      sortable: true,
    },
    {
      key: "edit",
      label: "Editar",
    }
  ]
}